import { render, staticRenderFns } from "./PostTooltip.vue?vue&type=template&id=3be61f85&"
import script from "./PostTooltip.vue?vue&type=script&lang=js&"
export * from "./PostTooltip.vue?vue&type=script&lang=js&"
import style0 from "./post-tooltip.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports